// Application configuration
export const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:3001' 
    : window.location.hostname.includes('ripkord.kew.bar')
    ? 'https://api.ripkord.kew.bar'
    : `${window.location.protocol}//${window.location.hostname}:3001`);

// Tenor GIF API configuration
export const TENOR_API_KEY = process.env.REACT_APP_TENOR_API_KEY || 'AIzaSyAyimkuYQYF_FXVALexPuGQctUWRURdCYQ';
export const TENOR_CLIENT_KEY = 'ripkord';

// Brand colors
export const COLORS = {
  // Primary brand color
  PRIMARY: '#5865F2',
  PRIMARY_DARK: '#4752C4',
  
  // Text colors
  TEXT_NORMAL: '#dcddde',
  TEXT_MUTED: '#b9bbbe',
  TEXT_LINK: '#00b0f4',
  
  // Background colors
  BG_PRIMARY: '#36393f',
  BG_SECONDARY: '#2f3136',
  BG_TERTIARY: '#202225',
  BG_MODIFIER: '#40444b',
  
  // Role default colors
  ROLE_DEFAULT: '#808080',
  ROLE_MEMBER: '#b9bbbe',
  
  // Status colors
  STATUS_ONLINE: '#3ba55d',
  STATUS_IDLE: '#faa81a',
  STATUS_DND: '#ed4245',
  STATUS_OFFLINE: '#747f8d',
  
  // Interactive colors
  INTERACTIVE_NORMAL: '#b9bbbe',
  INTERACTIVE_HOVER: '#dcddde',
  INTERACTIVE_ACTIVE: '#fff',
  INTERACTIVE_MUTED: '#4f545c',
  
  // Accent colors
  SUCCESS: '#3ba55d',
  WARNING: '#faa81a',
  DANGER: '#ed4245',
  INFO: '#5865F2',
};

// Default role color presets
export const COLOR_PRESETS = [
  '#5865F2', // Blurple
  '#57F287', // Green
  '#FEE75C', // Yellow
  '#EB459E', // Fuchsia
  '#ED4245', // Red
  '#F26522', // Orange
  '#99AAB5', // Gray
  '#FFFFFF', // White
  '#1ABC9C', // Teal
  '#3498DB', // Blue
  '#9B59B6', // Purple
  '#E91E63', // Pink
  '#F1C40F', // Gold
  '#E67E22', // Dark Orange
  '#95A5A6', // Light Gray
  '#34495E', // Dark Gray
  '#11806A', // Dark Teal
  '#206694', // Dark Blue
  '#71368A', // Dark Purple
  '#AD1457', // Dark Pink
];
